<template>
  <v-expansion-panel-text>
    <questionnaire-form-constructor
      :questions="questions"
      :attachmentType="attachmentType"
      :attachmentId="attachmentId"
    />
  </v-expansion-panel-text>
</template>

<script setup>

import QuestionnaireFormConstructor from '@/components/mission-planning/questionnaires/parts/QuestionnaireFormConstructor.vue';

const props = defineProps({
  questions: {
    type: Object,
    required: true
  },
  attachmentType: {
    type: String,
    required: false
  },
  attachmentId: {
    type: [Number, String],
    required: false
  },
});
</script>